const LEGEND = [
  {
    question: "Is the teacher creating the conditions for fluency to emerge?",
    scores: [
      { value: 1, label: "Highly teacher-led" },
      { value: 2, label: "Mostly teacher-led" },
      { value: 3, label: "Balanced" },
      { value: 4, label: "Student-centered" },
      { value: 5, label: "Fluency-oriented" },
    ],
  },
  {
    question:
      "How effectively does the teacher adapt their role to support the student?",
    scores: [
      { value: 1, label: "Presence not yet aligned" },
      { value: 2, label: "Developing presence" },
      { value: 3, label: "Adequate presence" },
      { value: 4, label: "Adaptive presence" },
      { value: 5, label: "Highly attuned presence" },
    ],
  },
  {
    question: "Does the teacher's clarity support communication?",
    scores: [
      { value: 1, label: "Clarity not easily accessible" },
      { value: 2, label: "Inconsistent clarity" },
      { value: 3, label: "Functional clarity" },
      { value: 4, label: "Effective clarity" },
      { value: 5, label: "Clarity that drives communication" },
    ],
  },
];

export function CoordinatorReviewScoreLegend() {
  return (
    <div className={"flex flex-col gap-4"}>
      {LEGEND.map((item, i) => (
        <div key={i}>
          <p className={"text-xs font-semibold text-slate-600 mb-1"}>
            {i + 1}. {item.question}
          </p>
          <div className={"flex flex-col gap-0.5"}>
            {item.scores.map((s) => (
              <div key={s.value} className={"flex items-center gap-2"}>
                <span
                  className={
                    "w-5 h-5 rounded text-xs font-bold flex items-center justify-center bg-slate-100 text-slate-600 flex-shrink-0"
                  }
                >
                  {s.value}
                </span>
                <span className={"text-xs text-slate-500"}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
